export const NAMESPACE = 'customer';
export const CUSTOMER_BASE = `${NAMESPACE}/CUSTOMER_BASE`;
export const GET_CUSTOMER = `${NAMESPACE}/GET_CUSTOMER`;
export const SET_CUSTOMER = `${NAMESPACE}/SET_CUSTOMER`;
export const CUSTOMER_ERROR = `${NAMESPACE}/CUSTOMER_ERROR`;
export const UPDATING = `${NAMESPACE}/UPDATING`;
